var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#827c78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.273 10.921V5.08c0-.395-.326-.715-.728-.715-.401 0-.727.32-.727.715v5.852c.006.391.33.705.727.705.402 0 .728-.32.728-.715zM10.182 10.921V5.08c0-.395-.326-.715-.727-.715-.402 0-.728.32-.728.715v5.852c.006.391.33.705.728.705.401 0 .727-.32.727-.715z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.773 3.185h.62v7.888c.003 1.917 1.731 3.47 3.865 3.472h5.484c2.134-.002 3.862-1.555 3.865-3.472V3.185h.62c.427 0 .773-.311.773-.695 0-.383-.346-.694-.773-.694h-3.886v-.308C11.34.667 10.599.001 9.685 0h-3.37C5.401.001 4.66.667 4.66 1.488v.308H.773c-.427 0-.773.31-.773.694 0 .384.346.695.773.695zm5.432-1.697c0-.055.05-.099.11-.099h3.37c.06 0 .11.044.11.1v.307h-3.59v-.308zM2.939 3.185h10.122v7.888c-.001 1.15-1.039 2.082-2.319 2.083H5.258c-1.28 0-2.318-.933-2.319-2.083V3.185z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ee799aaea70db739170843b310601ce7.svg";
export { ForwardRef as ReactComponent };